<ng-template #addContactTypeEle let-modal>
  <div class="modal-header">
	<h4 class="modal-title">Contact Type</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
	  <i class="fa fa-close"></i>
	</button>
  </div>
  <form [formGroup]="contactTypeForm" (ngSubmit)="addOrUpdateContactType()">
	<div class="modal-body text-dark">
		<div class="row" *ngIf="isProtectedContact">
			<div class="col-12 mb-3">
				<div class="alert alert-info">
					This contact role is <strong>system-defined</strong> and cannot be modified.
				</div>
			</div>
		</div>

	  <div class="row">
		<div class="col-md-6 mb-3">
		  <mat-form-field appearance="outline" class="w-100">
			<mat-label>Contact Type</mat-label>
			<input type="text" class="text-let m-0 p-0" matInput formControlName="contact_type" />
		  </mat-form-field>
		</div>
		<div class="col-md-6 mb-3">
		  <mat-form-field appearance="outline" class="w-100">
			<mat-label>Contact Role</mat-label>
			<input type="text" class="text-let m-0 p-0" matInput formControlName="contact_role" />
		  </mat-form-field>
		</div>
	  </div>
	</div>
	<div class="modal-footer text-end">
	  <button mat-stroked-button color="primary" type="submit" [disabled]="!contactTypeForm.valid">
		<mat-icon>save</mat-icon> Save
	  </button>
	</div>
  </form>
</ng-template>

<ng-template #addCustomer let-modal>
	<div class="modal-header">
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">

			<div class="col-12">
				<form [formGroup]="customerTypeForm">
					<mat-form-field appearance="outline">
						<mat-label>Customer Type</mat-label>
						<input type="text" class="text-let m-0 p-0" matInput formControlName="typename" />
					</mat-form-field>

					<mat-form-field appearance="outline">
						<mat-label>Address Type</mat-label>
						<mat-select formControlName="address_type">
							<mat-option [value]="'2'">Visible POS</mat-option>
							<mat-option [value]="'1'">Hide from POS</mat-option>
						</mat-select>
					</mat-form-field>

					<button mat-stroked-button color="primary" aria-label="Save" (click)="addCustomerType()" class="mt-2">
						<mat-icon>save</mat-icon> Save
					</button>
				</form>

			</div>
		</div>
	</div>

	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #editExclusions let-modal>
	<div class="modal-header">
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<h4> Exclusion Rules for {{editrule_name}}</h4>
		<div class="row">
			<div class="col-12">
				<table class="table table-striped">
					<tbody>
						<ng-container *ngIf="ruleset.length != 0">
							<tr *ngFor="let rule of ruleset;">
								<td> {{ rule.description }} </td>
								<td><button mat-stroked-button (click)="editRule(rule)"><mat-icon>edit</mat-icon></button><button mat-stroked-button (click)="deleteRule(rule)"><mat-icon>delete</mat-icon></button></td>
							</tr>
						</ng-container>
						<tr *ngIf="ruleset.length == 0">
							<td> No Rules Defined </td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<form [formGroup]="exclusionForm">
			<div class="row">
				<div class="col-3">
					<mat-form-field appearance="outline">
						<mat-label>Rule Type</mat-label>
						<mat-select formControlName="rule_type" (selectionChange)="typechange()">
							<mat-option *ngFor="let k of ruletypes | keyvalue" [value]="k.key">{{k.value}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div class="col-3">
					<mat-form-field appearance="outline">
						<mat-label>Inclusive</mat-label>
						<mat-select formControlName="rule_inclusive">
							<mat-option value="0">Not Equal To</mat-option>
							<mat-option value="1">Equal To</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3" *ngIf="editrule_type == 'P'">
					<mat-form-field appearance="outline">
						<mat-label>Product Line</mat-label>
						<mat-select formControlName="rule_value">
							<mat-option *ngFor="let k of prodlines" [value]="k.line_field">{{k.line_description}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3" *ngIf="editrule_type == 'C'">
					<mat-form-field appearance="outline">
						<mat-label>Category</mat-label>
						<mat-select formControlName="rule_value">
							<mat-option *ngFor="let k of categories" [value]="k.categoryid">{{k.categorydescription}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3" *ngIf="editrule_type == 'B'">
					<mat-form-field appearance="outline">
						<mat-label>Brand</mat-label>
						<mat-select formControlName="rule_value">
							<mat-option *ngFor="let k of brands" [value]="k.manufacturer_id">{{k.name}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3" *ngIf="editrule_type == 'S'">
					<mat-form-field appearance="outline">
						<mat-label>Item Number</mat-label>
						<input matInput formControlName="rule_value" />
					</mat-form-field>
				</div>
				<div class="col-3">
					<button mat-stroked-button color="success" aria-label="" (click)="saveRule()" class="mt-2">
						<mat-icon>save</mat-icon> Save
					</button>
				</div>
			</div>
		</form>
	</div>

	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #addVendor let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Edit</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-header text-center">
					<h4 class="card-title text-center"></h4>
				</div>
				<div class="card-body text-center">
					<div class="row">
						<div class="col-12">
							<form [formGroup]="vendorTypeForm">
								<mat-form-field appearance="outline">
									<mat-label>Vendor Type</mat-label>
									<input type="text" class="text-let m-0 p-0" matInput formControlName="typename" />
								</mat-form-field>
								<button mat-stroked-button color="success" aria-label="" (click)="addVendorType()" class="mt-2">
									<mat-icon>save</mat-icon> Save
								</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #addProductType let-modal>
	<div class="modal-header border-bottom">
		<h4 class="modal-title mb-0" id="modal-product-type-title">Product type (MB flag)</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<form [formGroup]="productTypeForm" id="productTypeForm" class="product-type-modal" (ngSubmit)="saveProductType(modal)">
		<div class="modal-body text-dark">
			<div class="row g-3">
				<div class="col-sm-4 col-md-3">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>MB flag</mat-label>
						<input type="text" matInput formControlName="label" maxlength="1" autocomplete="off" class="text-uppercase" />
						<mat-hint>Single character</mat-hint>
					</mat-form-field>
				</div>
				<div class="col-sm-8 col-md-9">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Description</mat-label>
						<input type="text" matInput formControlName="description" maxlength="24" autocomplete="off" />
						<mat-hint align="end">{{ (productTypeForm.get('description').value || '').length }} / 24</mat-hint>
					</mat-form-field>
				</div>
			</div>
			<input type="hidden" formControlName="original_label" aria-hidden="true" />
			<div class="alert alert-light border small py-2 px-3 mb-0 mt-2" role="note">
				<strong>Rename:</strong> changing the MB flag updates <code>stockmaster.mbflag</code> for every item that used the previous letter.
			</div>
			<p class="product-type-section-label mb-2 mt-4">Behavior</p>
			<div class="product-type-toggle-grid">
				<div class="product-type-toggle-cell">
					<mat-slide-toggle formControlName="createmovements" color="primary">Create stock movements</mat-slide-toggle>
				</div>
				<div class="product-type-toggle-cell">
					<mat-slide-toggle formControlName="isdefault" color="primary">Default for new items</mat-slide-toggle>
					<span class="product-type-toggle-hint">Only one type should be default.</span>
				</div>
				<div class="product-type-toggle-cell">
					<mat-slide-toggle formControlName="haschildren" color="primary">Has children (kit / BOM)</mat-slide-toggle>
				</div>
				<div class="product-type-toggle-cell">
					<mat-slide-toggle formControlName="requiresconfig" color="primary">Requires configuration</mat-slide-toggle>
				</div>
				<div class="product-type-toggle-cell product-type-toggle-cell-wide">
					<mat-slide-toggle formControlName="requirespick" color="primary">Requires warehouse pick</mat-slide-toggle>
					<span class="product-type-toggle-hint">Used by receiving and order-pick logic.</span>
				</div>
				<div class="product-type-toggle-cell product-type-toggle-cell-wide">
					<mat-slide-toggle formControlName="reducesstock" color="primary">Reduces stock (writes locstock)</mat-slide-toggle>
					<span class="product-type-toggle-hint">Disable for grouping items like mix-and-match kits.</span>
				</div>
			</div>
		</div>
		<div class="modal-footer border-top bg-light">
			<button mat-button type="button" (click)="modal.dismiss('cancel')">Cancel</button>
			<button mat-flat-button color="primary" type="submit" [disabled]="!productTypeForm.valid || productTypeSaving">
				<mat-icon class="save-icon">save</mat-icon>
				Save
			</button>
		</div>
	</form>
</ng-template>

<ng-template #addSalesTypeEle let-modal>
	<!-- Modal Header -->
	<div class="modal-header">
		<h5 class="modal-title">Add or Update Sales Type</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-times"></i>
		</button>
	</div>

	<div class="modal-body text-dark">

		<div class="row">
			<div class="col-12">
				<form [formGroup]="salesTypeForm">
					<div class="sales-type-form-container">
						<div class="form-card w-100">
							<div class="row mb-3">
								<!-- Sales Type -->
								<div class="col-md-4">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Sales Type (Abbreviation)</mat-label>
										<input type="text" matInput formControlName="typeabbrev" placeholder="Enter Sales Type Abbreviation" />
									</mat-form-field>
								</div>

								<!-- Name -->
								<div class="col-md-4">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Sales Type Name</mat-label>
										<input type="text" matInput formControlName="sales_type" placeholder="Enter Sales Type Name" />
									</mat-form-field>
								</div>

								<!-- Cost Multiplier -->
								<div class="col-md-4">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Cost Multiplier</mat-label>
										<input type="number" matInput formControlName="costMultiplier" placeholder="Enter Cost Multiplier (e.g., 1.2)" />
									</mat-form-field>
								</div>
							</div>
							<div class="row mb-3">
								<!-- Loyalty Points -->
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Loyalty Points</mat-label>
										<input type="number" matInput formControlName="loyaltypoints" placeholder="Enter Loyalty Points" />
									</mat-form-field>
								</div>

								<!-- Price Book Toggle -->
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Price Book</mat-label>
										<mat-select formControlName="ispricebook">
											<mat-option [value]="'0'">No</mat-option>
											<mat-option [value]="'1'">Yes</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<!-- Fall Back Level -->
								<div class="col-md-6">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Fall Back Level</mat-label>
										<mat-select formControlName="fallback">
											<mat-option [value]="type.typeabbrev" *ngFor="let type of salestypes">
												{{ type.typeabbrev }} - {{ type.sales_type }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

							</div>
							<div class="row">
								<!-- Table Name -->
								<div class="col-md-3" [ngClass]="(salesTypeForm.get('ispricebook') && salesTypeForm.get('ispricebook').value == '1') ? '' : 'd-none'">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Table Name</mat-label>
										<input type="text" matInput formControlName="tablename" placeholder="Enter Table Name" />
									</mat-form-field>
								</div>
							</div>
							<div class="row mt-3 pt-3 border-top">
								<div class="col-12">
									<h6 class="small text-uppercase text-muted fw-bold mb-1">Sales type settings</h6>
									<p class="small text-muted mb-2">Use this button to save the fields above (abbreviation, name, multipliers, price-book flag, fallback, etc.). It does <strong>not</strong> post spreadsheet prices.</p>
									<button
										type="button"
										class="btn btn-success"
										[disabled]="isSaving"
										(click)="addSalesType()">
										<span *ngIf="!isSaving">
											<i class="fa fa-save"></i> Save sales type
										</span>
										<span *ngIf="isSaving">
											<i class="fa fa-spinner fa-spin"></i> Saving…
										</span>
									</button>
									<div class="mt-3" *ngIf="salesTypeSaveResult">
										<div class="alert mb-0" [ngClass]="salesTypeSaveResult.ok ? 'alert-success' : 'alert-danger'" role="alert">
											<h6 class="alert-heading mb-2">{{ salesTypeSaveResult.title }}</h6>
											<ul class="mb-3 ps-3 small" *ngIf="salesTypeSaveResult.lines?.length">
												<li *ngFor="let line of salesTypeSaveResult.lines">{{ line }}</li>
											</ul>
											<button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="dismissSalesTypeSavePanel()">Hide summary</button>
											<button type="button" class="btn btn-sm btn-primary" (click)="closeSalesTypeModalAfterSave()">Close window</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				<ng-container *ngIf="salesTypeForm.get('ispricebook') && salesTypeForm.get('ispricebook').value == '1'">
					<div *ngIf="pricebookResumeOffer" class="alert alert-warning border-0 shadow-sm mb-3 py-3 px-3 d-flex flex-wrap align-items-center justify-content-between gap-2" role="status">
						<div class="small" style="min-width: 220px">
							<div class="fw-semibold mb-1">Resume pricebook staging?</div>
							<div class="text-muted">
								{{ pricebookResumeOffer.rowCount }} row(s), {{ pricebookResumeOffer.matchedCount }} matched, {{ pricebookResumeOffer.postedCount }} posted
								<span *ngIf="pricebookResumeOffer.sourceFilename"> — {{ pricebookResumeOffer.sourceFilename }}</span>
							</div>
						</div>
						<div class="d-flex flex-wrap gap-2">
							<button type="button" class="btn btn-sm btn-primary" (click)="continuePricebookStagingResume()">Continue</button>
							<button type="button" class="btn btn-sm btn-outline-secondary" (click)="abandonPricebookStagingResumeOffer()">Discard staging</button>
						</div>
					</div>
					<!-- Instructions: collapsed by default -->
					<mat-expansion-panel class="pricebook-help-panel mb-3" [expanded]="false">
						<mat-expansion-panel-header>
							<mat-panel-title>How to Update the PriceBook</mat-panel-title>
						</mat-expansion-panel-header>
						<div class="card-body border-0 p-0 pt-1">
							<ol class="mb-0 ps-3">
								<li>
									<strong>Turn On "New PriceBook":</strong> Use the <em>New PriceBook</em> switch only if you're creating a new PriceBook table. Leave it off if you're adding to an existing PriceBook.
								</li>
								<li>
									<strong>Get Your File Ready:</strong> Make sure your file is a CSV/XLS/XLSX. Don’t worry—file names and column headers will be cleaned up automatically to remove invalid characters. These headers <code>brand</code>, <code>price</code>, and <code>partno</code>  are REQUIRED, AND REMOVE FORMULAS!.
								</li>
								<li>
									<strong>Upload the File:</strong> Drag and drop your file into the upload box or click to choose a file. You can only upload one file at a time.
								</li>
								<li>
									<strong>Match Your Data:</strong> After uploading, you’ll need to map your file's columns (e.g., <code>brand</code>, <code>partno</code>, <code>price</code>) to the required fields. This step ensures everything lines up correctly.
								</li>
								<li>
									<strong>Stock ID Matching:</strong> The system will automatically match <code>brand</code> and <code>partno</code> to find the right <code>stockid</code>. If needed, it will clean up the data and try again.
								</li>
								<li>
									<strong>Save sales type:</strong> At the top of this window — saves the <strong>sales type</strong> record only (abbreviation, name, cost multiplier, loyalty, price-book flag, fallback, etc.). It does <strong>not</strong> upload spreadsheet prices.
								</li>
								<li>
									<strong>Final post matched prices:</strong> At the <strong>bottom</strong> of the preview card after you upload — sends only rows that have a <strong>stock ID</strong> and mapped <strong>price</strong> to update <strong>prices</strong> for this sales type.
								</li>
							</ol>
						</div>
					</mat-expansion-panel>

					<!-- Toggle for New PriceBook -->
					<div class="form-group mb-4 mt-3">
						<mat-slide-toggle [formControl]="salesTypeForm.get('newpricebook')" class="d-flex align-items-center">
							<strong>Create New PriceBook</strong>
						</mat-slide-toggle>
					</div>

					<!-- Reading / parsing file (large sheets can block the UI briefly) -->
					<div *ngIf="isProcessing && !uploaddata?.header" class="pricebook-card mb-3">
						<div class="card-body text-center py-5">
							<mat-spinner class="d-inline-block" diameter="48"></mat-spinner>
							<p class="mb-1 mt-3 fw-semibold">Loading file…</p>
							<p class="small text-muted mb-0" *ngIf="files[0]?.name"><strong>{{ files[0].name }}</strong></p>
							<p class="small text-muted mb-0">Reading and building the preview may take a moment for large spreadsheets.</p>
							<button type="button" class="btn btn-sm btn-outline-light mt-3" (click)="cancelPricebookParsing()">Cancel</button>
						</div>
					</div>

					<!-- File upload (idle) -->
					<div *ngIf="!isProcessing && !uploaddata?.header" class="pricebook-card">
						<div class="card-body text-center">
							<ngx-dropzone class="pricebook-dropzone" [multiple]="false" (change)="onSelect($event)" required>
								<ngx-dropzone-label>
									Drop file here or click to upload
								</ngx-dropzone-label>
								<ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
									<ngx-dropzone-label class="text-info">
										<strong>{{ f.name }}</strong> ({{ f.type }})
									</ngx-dropzone-label>
								</ngx-dropzone-preview>
							</ngx-dropzone>
						</div>
					</div>

					<!-- Data preview and mapping -->
					<div *ngIf="uploaddata?.header" class="pricebook-card">
						<div class="pricebook-card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
							<span>Data Preview for Table: <span *ngIf="tablename">{{ tablename }}</span></span>
							<button type="button" class="btn btn-sm btn-outline-light" (click)="resetPricebookUpload()">
								<mat-icon class="align-middle">refresh</mat-icon> Reset upload
							</button>
						</div>
						<div class="card-body">
							<div class="d-flex flex-wrap align-items-start align-items-md-center justify-content-between gap-2 mb-2">
								<div class="small text-muted">
									Matched: {{ pricebookMatchedDisplayCount }} · Unmapped: {{ pricebookUnmappedDisplayCount }}
								</div>
								<div class="d-flex flex-wrap align-items-center gap-2 ms-md-auto">
									<mat-form-field appearance="outline" class="pricebook-batch-limit-field">
										<mat-label>Batch limit</mat-label>
										<input matInput type="number" name="pricebookBatchLimitStv" [(ngModel)]="pricebookBatchLimit" [min]="pricebookBatchLimitMin" [max]="pricebookBatchLimitMax" step="1" [disabled]="isSearching || isPostingBatches" />
										<mat-hint>{{ pricebookBatchLimitMin }}–{{ pricebookBatchLimitMax }} rows per request</mat-hint>
									</mat-form-field>
									<button mat-stroked-button color="primary" type="button" [disabled]="isSearching || isPostingBatches" (click)="searchMissingPricebookStockIds()">
										Find Missing Stock IDs
									</button>
								</div>
							</div>
							<div *ngIf="isSearching" class="pricebook-progress-panel alert alert-primary border-0 shadow-sm mb-3 py-3 px-3" role="status">
								<div class="d-flex flex-wrap align-items-start gap-3 mb-2">
									<mat-spinner diameter="32" class="flex-shrink-0"></mat-spinner>
									<div class="flex-grow-1" style="min-width: 200px">
										<div class="fw-semibold">Matching brand / part number to stock IDs</div>
										<div class="small opacity-90 mt-1">
											Sending batches to the server. Matched and unmapped counts update as each batch finishes.
										</div>
									</div>
								</div>
								<mat-progress-bar mode="determinate" [value]="pricebookLookupProgressPct"></mat-progress-bar>
								<div class="small mt-2 d-flex flex-wrap align-items-baseline">
									<ng-container *ngIf="pricebookScratchTablename; else pricebookClientLookupBatchLine">
										<span class="mr-3 mb-1">Server batch <strong>{{ currentBatch }}</strong></span>
										<span class="mr-3 mb-1">Rows processed (this run): <strong>{{ totalProcessed }}</strong></span>
									</ng-container>
									<ng-template #pricebookClientLookupBatchLine>
										<span class="mr-3 mb-1">Batch <strong>{{ currentBatch }}</strong> of <strong>{{ totalBatches }}</strong></span>
										<span class="mr-3 mb-1">Rows covered: <strong>{{ totalProcessed }}</strong></span>
									</ng-template>
									<span class="mr-3 mb-1">Matched: <strong>{{ pricebookMatchedDisplayCount }}</strong></span>
									<span class="mb-1">Unmapped: <strong>{{ pricebookUnmappedDisplayCount }}</strong></span>
								</div>
							</div>
							<div *ngIf="isPostingBatches" class="pricebook-progress-panel alert alert-success border-0 shadow-sm mb-3 py-3 px-3" role="status">
								<div class="d-flex flex-wrap align-items-start gap-3 mb-2">
									<mat-spinner diameter="32" class="flex-shrink-0"></mat-spinner>
									<div class="flex-grow-1" style="min-width: 200px">
										<div class="fw-semibold">Posting matched prices</div>
										<div class="small opacity-90 mt-1">Writing prices for this sales type. This can take a while on large files.</div>
									</div>
								</div>
								<mat-progress-bar mode="determinate" [value]="pricebookPostingProgressPct"></mat-progress-bar>
								<div class="small mt-2 d-flex flex-wrap align-items-baseline">
									<ng-container *ngIf="pricebookScratchTablename; else pricebookClientPostBatchLine">
										<span class="mr-3 mb-1">Server batch <strong>{{ postingCurrentBatch }}</strong></span>
									</ng-container>
									<ng-template #pricebookClientPostBatchLine>
										<span class="mr-3 mb-1">Batch <strong>{{ postingCurrentBatch }}</strong> of <strong>{{ postingTotalBatches }}</strong></span>
									</ng-template>
									<span class="mr-3 mb-1">Rows sent so far: <strong>{{ postingProcessed }}</strong></span>
									<span class="mr-3 mb-1 text-success">Succeeded: <strong>{{ postingSucceeded }}</strong></span>
									<span class="mb-1" [class.text-danger]="postingFailed > 0">Failed: <strong>{{ postingFailed }}</strong></span>
								</div>
							</div>
							<div *ngIf="pricebookPostSummaryLines?.length && !isPostingBatches" class="alert alert-light border py-2 small mb-2 mb-md-3" role="status">
								<strong class="d-block mb-1">Last post summary</strong>
								<ul class="mb-0 ps-3">
									<li *ngFor="let line of pricebookPostSummaryLines">{{ line }}</li>
								</ul>
							</div>
							<div *ngIf="pricebookUnmappedDisplayCount" class="alert alert-info py-2 small mb-2 mb-md-3">
								<strong>{{ pricebookUnmappedDisplayCount }}</strong> row(s) have no stock ID and will <strong>not</strong> be included in <strong>Final post matched prices</strong> (only matched rows are sent). Use <em>Find Missing Stock IDs</em> or export from the <em>Unmapped</em> tab if you want to fix them.
							</div>
							<div
								*ngIf="pricebookLastLookupNewMatchCount > 0 && !isSearching"
								class="alert alert-success py-2 small mb-2 mb-md-3 d-flex flex-wrap justify-content-between align-items-center">
								<span>
									<strong>{{ pricebookLastLookupNewMatchCount }}</strong> row(s) received a stock ID in the last lookup
									<span class="text-muted">(green highlight on <em>Map &amp; sheet</em> and <em>Matched</em>)</span>.
								</span>
								<button type="button" class="btn btn-link btn-sm py-0 text-nowrap" (click)="clearPricebookLookupMatchHighlights()">Clear highlights</button>
							</div>
							<mat-tab-group animationDuration="0ms">
								<mat-tab>
									<ng-template mat-tab-label>
										Map &amp; sheet <mat-icon class="align-middle ms-1">table_chart</mat-icon>
									</ng-template>
									<div class="pricebook-preview-scroll mt-3">
										<table class="table table-bordered table-sm pricebook-preview-table mb-0">
											<thead class="thead-dark sticky-header">
												<tr>
													<th *ngFor="let col of uploaddata.header" scope="col">
														{{ col }}
													</th>
												</tr>
											</thead>
											<tbody>
												<tr class="pricebook-map-row">
													<td *ngFor="let col of uploaddata.header">
														<ng-container *ngIf="pricebookScratchTablename && col === 'stockid'; else pricebookMapSelectCell">
															<span class="small text-muted">System match</span>
														</ng-container>
														<ng-template #pricebookMapSelectCell>
															<select
																class="form-select form-select-sm pricebook-map-select"
																[ngClass]="'mapped-' + (mapping[col] || 'ignore')"
																[attr.aria-label]="'Map column ' + col + ' to system field'"
																[(ngModel)]="mapping[col]"
																(ngModelChange)="onMappingChanged()"
																required>
																<option *ngFor="let map of mapcols" [value]="map.field">
																	{{ map.label }}
																</option>
															</select>
														</ng-template>
													</td>
												</tr>
												<tr
													*ngFor="let row of pricebookMapRowsPage"
													[ngClass]="{
														'pricebook-row-lookup-matched': row._pricebookLookupMatched,
														'pricebook-row-has-stockid': pricebookScratchTablename && !row._pricebookLookupMatched && row.stockid
													}">
													<td
														*ngFor="let col of uploaddata.header"
														class="pricebook-cell"
														[attr.title]="row[col] | pricebookCellTitle">
														{{ row[col] | pricebookCellFormat: col }}
													</td>
												</tr>
											</tbody>
										</table>
										<mat-paginator
											*ngIf="(pricebookScratchTablename ? pricebookStagingRowsTotal : uploaddata.rows.length) > pricebookViewPageSizeOptions[0]"
											class="pricebook-sheet-paginator border-top bg-light"
											[length]="pricebookScratchTablename ? pricebookStagingRowsTotal : uploaddata.rows.length"
											[pageIndex]="pricebookMapPageIndex"
											[pageSize]="pricebookMapPageSize"
											[pageSizeOptions]="pricebookViewPageSizeOptions"
											[showFirstLastButtons]="true"
											(page)="onPricebookMapPaginator($event)">
										</mat-paginator>
									</div>
								</mat-tab>
								<mat-tab>
									<ng-template mat-tab-label>
										Matched ({{ pricebookMatchedDisplayCount }}) <mat-icon class="align-middle ms-1 text-success">check_circle</mat-icon>
									</ng-template>
									<div class="mt-3">
										<div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
											<p class="small text-muted mb-0" *ngIf="pricebookMatchedDisplayCount">
												Rows with a resolved stock ID. <strong>Final post matched prices</strong> at the bottom of this card sends <strong>only these rows</strong> to update prices. Rows without a stock ID are not sent (see the note above the tabs).
												<span *ngIf="pricebookLastLookupNewMatchCount > 0" class="d-block mt-1 text-success">Green-highlighted rows were matched in the last <em>Find Missing Stock IDs</em> run.</span>
											</p>
											<p class="small text-muted mb-0" *ngIf="!pricebookMatchedDisplayCount">
												No matched rows yet. Map columns and use <em>Find Missing Stock IDs</em> if needed.
											</p>
											<button
												mat-icon-button
												color="accent"
												type="button"
												matTooltip="Download matched rows as Excel"
												[attr.aria-label]="'Download matched rows as Excel'"
												[disabled]="!pricebookMatchedDisplayCount"
												(click)="exportMatchedPricebookXlsx()">
												<i class="fa fa-file-excel-o" aria-hidden="true"></i>
											</button>
										</div>
										<div class="pricebook-preview-scroll pricebook-unmapped-scroll" *ngIf="pricebookMatchedDisplayCount">
											<table class="table table-bordered table-sm pricebook-preview-table mb-0">
												<thead class="thead-dark sticky-header">
													<tr>
														<th *ngFor="let col of uploaddata.header" scope="col">{{ col }}</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let item of pricebookMatchedItemsPage" [class.pricebook-row-lookup-matched]="item._originalRow?._pricebookLookupMatched">
														<td
															*ngFor="let col of uploaddata.header"
															class="pricebook-cell"
															[attr.title]="item._originalRow[col] | pricebookCellTitle">
															{{ item._originalRow[col] | pricebookCellFormat: col }}
														</td>
													</tr>
												</tbody>
											</table>
											<mat-paginator
												*ngIf="(pricebookScratchTablename ? pricebookMatchedStagingTotal : matchedItems.length) > pricebookViewPageSizeOptions[0]"
												class="pricebook-sheet-paginator border-top bg-light"
												[length]="pricebookScratchTablename ? pricebookMatchedStagingTotal : matchedItems.length"
												[pageIndex]="pricebookMatchedPageIndex"
												[pageSize]="pricebookMatchedPageSize"
												[pageSizeOptions]="pricebookViewPageSizeOptions"
												[showFirstLastButtons]="true"
												(page)="onPricebookMatchedPaginator($event)">
											</mat-paginator>
										</div>
									</div>
								</mat-tab>
								<mat-tab>
									<ng-template mat-tab-label>
										Unmapped ({{ pricebookUnmappedDisplayCount }}) <mat-icon class="align-middle ms-1 text-warning">warning</mat-icon>
									</ng-template>
									<div class="mt-3">
										<div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
											<p class="small text-muted mb-0" *ngIf="pricebookUnmappedDisplayCount">
												These rows have no stock ID yet. Export to Excel, fix in your spreadsheet, then re-upload if needed.
											</p>
											<p class="small text-success mb-0" *ngIf="!pricebookUnmappedDisplayCount">
												All rows have a stock ID.
											</p>
											<button
												mat-icon-button
												color="primary"
												type="button"
												matTooltip="Download unmapped rows as Excel"
												[attr.aria-label]="'Download unmapped rows as Excel'"
												[disabled]="!pricebookUnmappedDisplayCount"
												(click)="exportUnmappedPricebookXlsx()">
												<i class="fa fa-file-excel-o" aria-hidden="true"></i>
											</button>
										</div>
										<div class="pricebook-preview-scroll pricebook-unmapped-scroll" *ngIf="pricebookUnmappedDisplayCount">
											<table class="table table-bordered table-sm pricebook-preview-table mb-0">
												<thead class="thead-dark sticky-header">
													<tr>
														<th *ngFor="let col of uploaddata.header" scope="col">{{ col }}</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let item of pricebookUnmatchedItemsPage">
														<td
															*ngFor="let col of uploaddata.header"
															class="pricebook-cell"
															[attr.title]="item._originalRow[col] | pricebookCellTitle">
															{{ item._originalRow[col] | pricebookCellFormat: col }}
														</td>
													</tr>
												</tbody>
											</table>
											<mat-paginator
												*ngIf="(pricebookScratchTablename ? pricebookUnmappedStagingTotal : unmatchedItems.length) > pricebookViewPageSizeOptions[0]"
												class="pricebook-sheet-paginator border-top bg-light"
												[length]="pricebookScratchTablename ? pricebookUnmappedStagingTotal : unmatchedItems.length"
												[pageIndex]="pricebookUnmatchedPageIndex"
												[pageSize]="pricebookUnmatchedPageSize"
												[pageSizeOptions]="pricebookViewPageSizeOptions"
												[showFirstLastButtons]="true"
												(page)="onPricebookUnmatchedPaginator($event)">
											</mat-paginator>
										</div>
									</div>
								</mat-tab>
							</mat-tab-group>

							<div *ngIf="uploaddata?.header" class="d-flex flex-column flex-md-row align-items-stretch align-items-md-end justify-content-between gap-2 border-top pt-3 mt-3">
								<p class="small text-muted mb-0">When you are ready, post prices for <strong>matched</strong> rows only (stock ID + price). Use <strong>Save sales type</strong> above for the sales type record.</p>
								<button
									mat-raised-button
									color="accent"
									type="button"
									class="align-self-stretch flex-shrink-0"
									style="min-width: 12rem"
									[disabled]="isSearching || isPostingBatches || !canFinalizePricebookPost"
									(click)="postPricebookBatches()">
									<span *ngIf="!isPostingBatches">Final post matched prices</span>
									<span *ngIf="isPostingBatches">Posting…</span>
								</button>
							</div>

							</div>
						</div>
					</ng-container>
			</div>
		</div>
	</div>

	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #addPaymentTermEle let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Payment Terms</h4>
		<button type="button" class="btn btn-sm btn-info me-2" (click)="openPaymentTermsHelp()" title="How Payment Terms Work">
			<i class="fa fa-question-circle"></i> Help
		</button>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark payment-terms-form-body">
		<form [formGroup]="paymentTermsForm" class="payment-terms-form">

			<!-- Basic Information -->
			<div class="form-section">
				<div class="row g-3">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Code</mat-label>
							<input type="text" matInput formControlName="termsindicator" maxlength="4" />
							<mat-hint>4 characters max (e.g., N30, COD)</mat-hint>
							<mat-error *ngIf="paymentTermsForm.get('termsindicator').hasError('required')">Required</mat-error>
						</mat-form-field>
					</div>
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Name</mat-label>
							<input type="text" matInput formControlName="terms" />
							<mat-hint>Display name for this payment term</mat-hint>
							<mat-error *ngIf="paymentTermsForm.get('terms').hasError('required')">Required</mat-error>
						</mat-form-field>
					</div>
				</div>
			</div>

			<!-- Due Date Type Selection -->
			<div class="form-section">
				<label class="section-label">When is payment due?</label>
				<div class="row g-3 align-items-end">
					<div class="col-md-8">
						<mat-radio-group formControlName="dueDateType" class="radio-group" (change)="onDueDateTypeChange()">
							<mat-radio-button value="days" class="radio-option">
								X days after invoice
							</mat-radio-button>
							<mat-radio-button value="dayOfMonth" class="radio-option">
								On day X of month
							</mat-radio-button>
							<mat-radio-button value="endOfMonth" class="radio-option">
								Last day of month
							</mat-radio-button>
						</mat-radio-group>
					</div>
					<div class="col-md-4" *ngIf="paymentTermsForm.get('dueDateType').value === 'days'">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Days</mat-label>
							<input type="number" min="0" matInput formControlName="daysbeforedue" (keyup)="getExampleDueDate()"/>
							<mat-hint>Add this many days to invoice date</mat-hint>
						</mat-form-field>
					</div>
					<div class="col-md-4" *ngIf="paymentTermsForm.get('dueDateType').value === 'dayOfMonth'">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Day</mat-label>
							<input type="number" min="1" max="31" matInput formControlName="dayinfollowingmonth" (keyup)="getExampleDueDate()"/>
							<mat-hint>Set due date to this day (31 = last day of month)</mat-hint>
						</mat-form-field>
					</div>
				</div>
				<div class="row g-3 mt-3">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Period Start Day</mat-label>
							<input type="number" min="1" max="31" matInput formControlName="agefrom" (keyup)="getExampleDueDate()"/>
							<mat-hint>Reserved for future use (default: 1)</mat-hint>
						</mat-form-field>
					</div>
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Month Rollover Threshold</mat-label>
							<input type="number" min="1" max="31" matInput formControlName="ageto" (keyup)="getExampleDueDate()"/>
							<mat-hint>If invoice day > this, move to next month first (default: 25, 31 = last day)</mat-hint>
						</mat-form-field>
					</div>
				</div>
			</div>

			<!-- Due Date Calculator Preview -->
			<div class="form-section calculator-section">
				<label class="section-label">Preview Due Date</label>
				<div class="calculator-box">
					<div class="row g-3 align-items-center">
						<div class="col-md-5">
							<mat-form-field appearance="outline" class="w-100">
								<mat-label>Invoice Date</mat-label>
								<input matInput [matDatepicker]="picker" [formControl]="exampleTranDate" (click)="picker.open()">
								<mat-datepicker-toggle matSuffix [for]="picker">
									<mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
								</mat-datepicker-toggle>
								<mat-datepicker #picker></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="col-md-2 text-center">
							<span class="arrow-icon">→</span>
						</div>
						<div class="col-md-5">
							<div class="due-date-display">
								<div *ngIf="calculatingDue" class="text-center py-2">
									<mat-spinner diameter="24"></mat-spinner>
								</div>
								<div *ngIf="!calculatingDue && duedate" class="due-date-result">
									{{duedate}}
								</div>
								<div *ngIf="!calculatingDue && !duedate" class="text-muted text-center py-2">
									Select a date
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Advanced Options: Statement Periods -->
			<div class="form-section advanced-section">
				<label class="section-label">Advanced Options</label>
				<div class="advanced-info">
					<small class="text-muted">Statement period settings</small>
				</div>
				<div class="row g-3 mt-2">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Statement Periods</mat-label>
							<input type="number" min="0" matInput formControlName="statementperiods" (keyup)="getExampleDueDate()"/>
							<mat-hint>Wait this many periods (each = next month + ~24 days)</mat-hint>
							<mat-error *ngIf="paymentTermsForm.get('statementperiods').hasError('required')">Required</mat-error>
						</mat-form-field>
					</div>
				</div>
			</div>

			<!-- Optional: Early Payment Discount -->
			<div class="form-section">
				<div class="row g-3">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Early Payment Discount (%)</mat-label>
							<input type="number" step="0.01" min="0" matInput formControlName="terms_discount" />
							<mat-hint>Optional (e.g., 2% for 2/10 Net 30)</mat-hint>
						</mat-form-field>
					</div>
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Number of Payments</mat-label>
							<input type="number" min="1" matInput formControlName="numpayments" />
							<mat-hint>Installments (default: 1)</mat-hint>
						</mat-form-field>
					</div>
				</div>
			</div>

			<!-- Payment Options -->
			<div class="form-section">
				<label class="section-label">Payment Options</label>
				<div class="checkbox-group">
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('collect_payment').value === '1'"
									  (change)="paymentTermsForm.get('collect_payment').setValue($event.checked ? '1' : '0')">
							Collect payment on order
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('onaccountallowed').value === '1'"
									  (change)="paymentTermsForm.get('onaccountallowed').setValue($event.checked ? '1' : '0')">
							Allow on account
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('order_entry').value === '1'"
									  (change)="paymentTermsForm.get('order_entry').setValue($event.checked ? '1' : '0')">
							Show in order entry
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('cc_process').value === '1'"
									  (change)="paymentTermsForm.get('cc_process').setValue($event.checked ? '1' : '0')">
							Require credit card
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('decline').value === '1'"
									  (change)="paymentTermsForm.get('decline').setValue($event.checked ? '1' : '0')">
							Allow card decline
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('donot_print').value === '1'"
									  (change)="paymentTermsForm.get('donot_print').setValue($event.checked ? '1' : '0')">
							Don't print on documents
						</mat-checkbox>
					</div>
				</div>
			</div>

			<!-- Actions -->
			<div class="form-actions">
				<button mat-stroked-button (click)="modal.dismiss()" class="me-2">Cancel</button>
				<button mat-raised-button color="primary" (click)="addPaymentTerm()" [disabled]="!paymentTermsForm.valid">
					Save
				</button>
			</div>
		</form>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #paymentTermsHelp let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Payment Terms - How It Works</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-12">
				<div class="card mb-3">
					<div class="card-header bg-primary text-white">
						<h6 class="mb-0"><i class="fa fa-calendar"></i> Due Date Configuration Fields</h6>
					</div>
					<div class="card-body text-dark">
						<div class="mb-3">
							<strong>Days:</strong>
							<p class="mb-0">Adds this many days to the invoice date. If "Day" is also set, days are added first, then the due date is set to the specified day of month.</p>
							<small class="text-muted">Example: 30 = Invoice date + 30 days (Net 30)</small>
						</div>

						<div class="mb-3">
							<strong>Day:</strong>
							<p class="mb-0">Sets the final due date to this day of the month (1-31). This happens after all other calculations (statement periods, days added, month rollovers). If set to 31, it means the last day of the month.</p>
							<small class="text-muted">Example: 10 = Due date will be the 10th of the calculated month</small>
						</div>

						<div class="mb-3">
							<strong>Statement Periods:</strong>
							<p class="mb-0">Number of statement periods to wait before calculating the due date. Each period: moves to the 1st of next month, then adds approximately 24 days (statement run day - 1). If the invoice date is after the statement run day, one extra period is added automatically.</p>
							<small class="text-muted">Example: 1 = Move to next month's 1st, add ~24 days, then continue calculation</small>
						</div>

						<div class="mb-3">
							<strong>Period Start Day:</strong>
							<p class="mb-0">Currently reserved for future use and does not affect due date calculations. Default value is 1.</p>
							<small class="text-muted">Note: This field is stored but not currently used in calculations</small>
						</div>

						<div class="mb-3">
							<strong>Month Rollover Threshold:</strong>
							<p class="mb-0">If the invoice day is greater than this value, the transaction is moved to the 1st of the next month BEFORE other calculations. This happens first, before statement periods or days are added. If set to 31, it means the last day of the month.</p>
							<small class="text-muted">Example: If set to 25, an invoice on the 26th is moved to the 1st of next month before calculating due date</small>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #addClubEle let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Club</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-12">
				<form [formGroup]="clubForm">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Club Name</mat-label>
						<input type="text" matInput formControlName="club" />
					</mat-form-field>
					<div class="text-end mt-3">
						<button mat-stroked-button (click)="modal.dismiss()" class="me-2">Cancel</button>
						<button mat-raised-button color="primary" (click)="addClub()" [disabled]="!clubForm.valid">Save</button>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #addClubEle let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Club</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-header text-center">
					<h4 class="card-title text-center"></h4>
				</div>
				<div class="card-body text-center">
					<div class="row">

						<form [formGroup]="clubForm" class="container">
							<div class="row">
								<div class="col-md-6 mb-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Name</mat-label>
										<input type="text" class="text-let m-0 p-0" matInput formControlName="club" />
									</mat-form-field>
								</div>
							</div>

							<div class="row">
								<div class="col-12 text-center">
									<button mat-stroked-button color="success" aria-label="" (click)="addClub()" class="mt-2">
										<mat-icon>save</mat-icon> Save
									</button>
								</div>
							</div>
						</form>


					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-5">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> System Types</h4>
						<p class="card-category text-right">System Types</p>
					</div>
					<div class="card-body">
						<mat-tab-group #tabPanel mat-align-tabs="start" class="" color="accent">
							<mat-tab label="Sales Types">
								<button mat-stroked-button color="success" aria-label="" (click)="addSalesTypeDisplay()" class="mt-2">
									<mat-icon>add</mat-icon> Add Sales Type
								</button>

								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>

								<table class="table table-sm mt-3">
									<tr>
										<th></th>
										<th>Abbreviation</th>
										<th>Type</th>
										<th>Cost x</th>
										<th>Loyalty Points</th>
										<th>Price Book</th>
									</tr>
									<tr *ngFor="let type of salestypes">
										<td>
											<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removeSalesType(type)">
												<mat-icon>remove</mat-icon>
											</button>
											<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editSalesTypeDispaly(type)">
												<mat-icon>edit</mat-icon>
											</button>
										</td>
										<td>{{ type.typeabbrev }}</td>
										<td>{{ type.sales_type }}</td>
										<td>{{ type.costMultiplier }}</td>
										<td>{{ type.loyaltypoints }}</td>
										<td>{{ yesNoValue(type.ispricebook) }}</td>
									</tr>
								</table>
							</mat-tab>
							<mat-tab label="Payment Types">
								<app-payment-types></app-payment-types>
							</mat-tab>
							<mat-tab label="Payment Terms">
								<div class="row mb-3 mt-3">
									<div class="col-md-6">
										<button mat-stroked-button color="success" aria-label="" (click)="addPaymentTermView()" class="mt-2">
											<mat-icon>add</mat-icon> Add Payment Term
										</button>
									</div>
									<div class="col-md-3">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Search</mat-label>
											<input matInput [(ngModel)]="paymentTermsSearchFilter" placeholder="Search by code or name">
											<mat-icon matPrefix>search</mat-icon>
										</mat-form-field>
									</div>
								</div>
								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>
								<div class="table-responsive">
									<table class="table table-sm mt-3">
										<thead>
											<tr>
												<th>Actions</th>
												<th>Code</th>
												<th>Name</th>
												<th>Customers</th>
												<th>Description</th>
												<th>Days After Invoice</th>
												<th>Due Day of Month</th>
												<th>Statement Periods</th>
												<th>Discount %</th>
												<th>Payments</th>
												<th>Require CC</th>
												<th>Collect Payment</th>
												<th>On Account</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let type of getFilteredPaymentTerms()">
												<td>
													<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removePaymentTerm(type)">
														<mat-icon>remove</mat-icon>
													</button>
													<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editPaymentTermDispaly(type)">
														<mat-icon>edit</mat-icon>
													</button>
												</td>
												<td><strong>{{ type.termsindicator }}</strong></td>
												<td>{{ type.terms }}</td>
												<td>{{ type.customer_count || 0 }}</td>
												<td>
													<small class="text-muted">{{ getPaymentTermDescription(type) }}</small>
												</td>
												<td>{{ type.daysbeforedue || '-' }}</td>
												<td>{{ type.dayinfollowingmonth || '-' }}</td>
												<td>{{ type.statementperiods || '-' }}</td>
												<td>{{ type.terms_discount || '0.00' }}%</td>
												<td>{{ type.numpayments || '1' }}</td>
												<td>{{ yesNoValue(type.cc_process) }}</td>
												<td>{{ yesNoValue(type.collect_payment) }}</td>
												<td>{{ yesNoValue(type.onaccountallowed) }}</td>
											</tr>
											<tr *ngIf="getFilteredPaymentTerms().length === 0">
												<td colspan="13" class="text-center text-muted">
													No payment terms found matching your search criteria.
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</mat-tab>
							<mat-tab label="Customer Types">
								<button mat-stroked-button color="success" aria-label="" (click)="addCustomerTypeView()" class="mt-2">
									<mat-icon>add</mat-icon> Add Customer Type
								</button>
								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>
								<table class="table table-sm mt-3">
									<tr>
										<th></th>
										<th>ID</th>
										<th>Name</th>
										<th></th>
									</tr>
									<tr *ngFor="let type of customertypes">
										<td>
											<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removeCustomerType(type)">
												<mat-icon>remove</mat-icon>
											</button>
											<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editCustomerTypeDisplay(type)">
												<mat-icon>edit</mat-icon>
											</button>
										</td>
										<td>{{ type.typeid }}</td>
										<td>{{ type.typename }}</td>
										<td><button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editCustomerTypeExclusions(type)">
												<mat-icon>block</mat-icon> Product Exclusions
											</button></td>
									</tr>
								</table>
							</mat-tab>
							<mat-tab label="Vendor Types">
								<button mat-stroked-button color="success" aria-label="" (click)="addVendorTypeDisplay()" class="mt-2">
									<mat-icon>add</mat-icon> Add Vendor Type
								</button>

								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>

								<table class="table table-sm mt-3">
									<tr>
										<th></th>
										<th>ID</th>
										<th>Name</th>
										<th></th>
									</tr>
									<tr *ngFor="let type of supptypes">
										<td>
											<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removeVendorType(type)">
												<mat-icon>remove</mat-icon>
											</button>
											<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editVendorTypeDisplay(type)">
												<mat-icon>edit</mat-icon>
											</button>
										</td>
										<td>{{ type.typeid }}</td>
										<td>{{ type.typename }}</td>
										<td></td>
									</tr>
								</table>
							</mat-tab>
							<mat-tab label="Product types (MB)">
								<button mat-stroked-button color="success" aria-label="" (click)="addProductTypeDisplay()" class="mt-2">
									<mat-icon>add</mat-icon> Add product type
								</button>
								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="productTypesLoading"></mat-progress-bar>
								<div class="table-responsive mt-3">
									<table class="table table-sm table-striped align-middle product-types-table">
										<thead>
											<tr>
												<th scope="col" class="product-types-col-actions">Actions</th>
												<th scope="col">MB flag</th>
												<th scope="col">Description</th>
												<th scope="col" class="text-center product-types-col-flag" title="Create stock movements">Movements</th>
												<th scope="col" class="text-center product-types-col-flag" title="Default type for new items">Default</th>
												<th scope="col" class="text-center product-types-col-flag" title="Has children (kit/BOM)">Children</th>
												<th scope="col" class="text-center product-types-col-flag" title="Requires configuration">Config</th>
												<th scope="col" class="text-center product-types-col-flag" title="Requires warehouse pick">Pick</th>
												<th scope="col" class="text-center product-types-col-flag" title="Writes locstock and affects QOH">Reduces stock</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let pt of productTypes">
												<td>
													<button mat-icon-button color="warn" aria-label="Delete product type" class="small-font" type="button" (click)="removeProductType(pt)">
														<mat-icon>remove</mat-icon>
													</button>
													<button mat-icon-button color="accent" aria-label="Edit product type" class="small-font" type="button" (click)="editProductTypeDisplay(pt)">
														<mat-icon>edit</mat-icon>
													</button>
												</td>
												<td><span class="fw-semibold font-monospace">{{ pt.label }}</span></td>
												<td>{{ pt.description }}</td>
												<td class="text-center"><mat-icon *ngIf="productTypeFlagOn(pt.createmovements)" class="product-types-yes">check</mat-icon></td>
												<td class="text-center"><mat-icon *ngIf="productTypeFlagOn(pt.isdefault)" class="product-types-yes">check</mat-icon></td>
												<td class="text-center"><mat-icon *ngIf="productTypeFlagOn(pt.haschildren)" class="product-types-yes">check</mat-icon></td>
												<td class="text-center"><mat-icon *ngIf="productTypeFlagOn(pt.requiresconfig)" class="product-types-yes">check</mat-icon></td>
												<td class="text-center"><mat-icon *ngIf="productTypeFlagOn(pt.requirespick)" class="product-types-yes">check</mat-icon></td>
												<td class="text-center"><mat-icon *ngIf="productTypeFlagOn(pt.reducesstock)" class="product-types-yes">check</mat-icon></td>
											</tr>
										</tbody>
									</table>
								</div>
							</mat-tab>
							<mat-tab label="Contact Types">
							  <button mat-stroked-button color="success" aria-label="" (click)="addContactTypeDisplay()" class="mt-2">
								<mat-icon>add</mat-icon> Add Contact Type
							  </button>

							  <mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>

							  <table class="table table-sm mt-3">
								<thead>
								  <tr>
									<th>Actions</th>
									<th>Type</th>
									<th>Role</th>
								  </tr>
								</thead>
								<tbody>
								  <tr *ngFor="let type of contacttypes">
									<td>
										<button mat-icon-button color="warn" aria-label="delete" class="small-font"
											(click)="removeContactType(type)"
											[disabled]="protectedRoles.includes(type.contact_role?.toUpperCase())">
											<mat-icon>remove</mat-icon>
										</button>
										<button mat-icon-button color="accent" aria-label="edit" class="small-font"
											(click)="editContactTypeDisplay(type)">
											<mat-icon>edit</mat-icon>
										</button>
									</td>

									<td>{{ type.contact_type }}</td>
									<td>{{ type.contact_role }}</td>
								  </tr>
								</tbody>
							  </table>
							</mat-tab>

							<mat-tab label="Clubs">
								<button mat-stroked-button color="success" aria-label="" (click)="addClubDisplay()" class="mt-2">
									<mat-icon>add</mat-icon> Add Club
								</button>

								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>

								<table class="table table-sm mt-3">
									<tr>
										<th></th>
										<th>ID</th>
										<th>Name</th>
										<th></th>
									</tr>
									<tr *ngFor="let type of clubs">
										<td>
											<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removeClub(type)">
												<mat-icon>remove</mat-icon>
											</button>
											<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editClubDisplay(type)">
												<mat-icon>edit</mat-icon>
											</button>
										</td>
										<td>{{ type.id }}</td>
										<td>{{ type.club }}</td>
										<td></td>
									</tr>
								</table>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>